import tw from "twin.macro";

export const HorizontalElementSpacingWrapper = tw.div`tw-mr-8`;
export const VerticalContainerSpacingWrapper = tw.div`tw-mb-32`;
